import { EntityDefinition } from '@/types/crud';

export const emailTemplateEntity: EntityDefinition = {
  name: 'emailTemplates',
  displayName: 'Email Templates',
  displayNameSingular: 'Email Template',
  apiEndpoint: '/generic/crm_email_templates',
  idField: 'id',
  nameField: 'name',
  copyable: true,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'name',
      label: 'Template Name',
      type: 'text',
      required: true,
      placeholder: 'Enter template name',
      order: 1
    },
    {
      key: 'category',
      label: 'Category',
      type: 'text',
      placeholder: 'Enter category (e.g., Welcome, Newsletter)',
      order: 2
    },
    {
      key: 'is_active',
      label: 'Active',
      type: 'checkbox',
      defaultValue: true,
      order: 3
    },
    {
      key: 'subject',
      label: 'Subject',
      type: 'text',
      required: true,
      placeholder: 'Enter email subject',
      order: 4,
      fullWidth: true
    },
    {
      key: 'content_html',
      label: 'Message',
      type: 'html',
      required: true,
      placeholder: 'Enter email message',
      order: 5,
      fullWidth: true
    },
    {
      key: 'created_by',
      label: 'Created By',
      type: 'text',
      hidden: true,
      order: 7
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 8
    },
    {
      key: 'updated_at',
      label: 'Updated',
      type: 'datetime',
      hidden: true,
      order: 9
    },
    {
      key: 'tenant_id',
      label: 'Tenant ID',
      type: 'text',
      hidden: true,
      order: 10
    }
  ],
  tableColumns: [
    {
      key: 'name',
      label: 'Template Name',
      sortable: true
    },
    {
      key: 'subject',
      label: 'Subject',
      sortable: true
    },
    {
      key: 'category',
      label: 'Category',
      sortable: true
    },
    {
      key: 'is_active',
      label: 'Active',
      sortable: true
    },
    {
      key: 'created_at',
      label: 'Created',
      sortable: true
    }
  ],
  searchFields: ['name', 'subject', 'category', 'content_html'],
  defaultSort: { field: 'created_at', direction: 'desc' }
};
